import { getFocusableElements } from "./get-focusable-elements";
import { getActiveElement } from "./get-active-element";

export const trapFocus = (
    hostElement: HTMLElement
): ((e: KeyboardEvent) => void) => {
    return (e) => {
        const tabPressed = e.key === "Tab";
        if (tabPressed) {
            const focusableElements = getFocusableElements(hostElement);

            const first = focusableElements[0];
            const last = focusableElements[focusableElements.length - 1];
            const activeElement = getActiveElement(hostElement);

            if (e.shiftKey) {
                if (activeElement === first && e.shiftKey) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (activeElement === last) {
                    e.preventDefault();
                    first.focus();
                } else return;
            }
        }
    };
};
